
import type React from "react"

import { useDispatch, useSelector } from "react-redux"
import { setShowLoginModal } from "../ui/uiSlice"
import type { RootState } from "../../store"
import { X } from "lucide-react"
import { useState } from "react"
import { useTheme } from "../../contexts/ThemeContext"
import useTranslation from "../../hooks/useTranslation"

export default function LoginModal() {
  const dispatch = useDispatch()
  const { showLoginModal } = useSelector((state: RootState) => state.ui)
  const { primaryColor } = useTheme()
  const { t } = useTranslation()
  const [phone, setPhone] = useState("")

  if (!showLoginModal) return null

  const handleClose = () => {
    dispatch(setShowLoginModal(false))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Handle phone number submission
    handleClose()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-t-3xl">
        <div className="p-4">
          <div className="flex justify-between items-center mb-6">
            <button onClick={handleClose} className="p-2">
              <X className="w-5 h-5" />
            </button>
            <h2 className="text-lg font-bold">{t('auth.enterPhoneNumber')}</h2>
            <div className="w-9"></div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={t('auth.phoneNumber')}
                className="w-full p-4 border border-gray-300 rounded-lg text-right"
                dir="rtl"
              />
            </div>

            <button
              type="submit"
              className="w-full py-3 rounded-lg text-white font-bold"
              style={{ backgroundColor: primaryColor }}
            >
              {t('common.continue')}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
